module.exports = __webpack_public_path__ + "static/icon-circle-calendar-69a0d44f67cb13abc8069698dda91eb2.png";